<template>
  <div class="mt-3">
    <form
      v-if="lstSolicitante.length == 0 || editConfig"
      @submit.prevent="editConfig ? editandoConfiguracao() : adicionaConfiguracao()"
      autocomplete="off"
    >
      <b-row>
        <b-col cols="12">
          <div class="titlePage mb-3">Configuração da Publicação</div>
        </b-col>
        <b-col cols="4" class="mt-4">
          <fcc-select
            v-model="configPublicacao.publicacaoGabarito"
            valueField="value"
            labelField="text"
            :clearable="false"
            :disabled="editConfig"
            @change="limpaCampos"
            :options="lstGabaritoProva"
          >
            Gabarito
          </fcc-select>
        </b-col>
        <b-col cols="12" sm="4" v-if="configPublicacao.publicacaoGabarito">
          Data/Hora Inicial de Acesso ao Gabarito
          <datetime
            v-model="configPublicacao.dtIniGabaritoAcesso"
            value-zone="America/Sao_Paulo"
            type="datetime"
            format="dd/MM/yyyy HH:mm"
            :min-datetime="capturaDataAtualSGP()"
            class="form-control"
            placeholder="__/__/____ __:__"
            required
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" sm="4" class="mt-4">
          <fcc-select
            v-model="configPublicacao.publicacaoProva"
            valueField="value"
            labelField="text"
            :clearable="false"
            :disabled="editConfig"
            @change="limpaCampos"
            :options="lstGabaritoProva"
          >
            Prova
          </fcc-select>
        </b-col>
        <template v-if="configPublicacao.publicacaoProva">
          <b-col cols="12" sm="4" class="mt-2">
            Data/Hora Inicial de Acesso a Prova
            <datetime
              v-model="configPublicacao.dtIniProvaAcesso"
              value-zone="America/Sao_Paulo"
              type="datetime"
              format="dd/MM/yyyy HH:mm"
              :min-datetime="capturaDataAtualSGP()"
              class="form-control"
              placeholder="__/__/____ __:__"
              required
            />
          </b-col>
          <b-col cols="12" sm="4" class="mt-2">
            Data/Hora Final de Acesso a Prova
            <datetime
              v-model="configPublicacao.dtFimProvaAcesso"
              value-zone="America/Sao_Paulo"
              type="datetime"
              format="dd/MM/yyyy HH:mm"
              :min-datetime="configPublicacao.dtIniProvaAcesso"
              class="form-control"
              placeholder="__/__/____ __:__"
              required
            />
          </b-col>
        </template>
      </b-row>
      <b-row class="mt-4">
        <b-col v-if="configPublicacao.publicacaoProva" cols="12" sm="4">
          <fcc-select
            v-model="configPublicacao.downloadProva"
            valueField="value"
            labelField="text"
            :clearable="false"
            :disabled="editConfig"
            :options="lstGabaritoProva"
          >
            Permitir Download
          </fcc-select>
        </b-col>
        <b-col cols="12" sm="4">
          <fcc-select
            v-model="configPublicacao.apCodOpcao"
            valueField="value"
            labelField="text"
            :clearable="false"
            :disabled="editConfig"
            :options="lstGabaritoProva"
          >
            Apresentar o Código da Opção
          </fcc-select>
        </b-col>
        <b-col cols="8" :class="configPublicacao.publicacaoProva ? 'mt-3' : ''">
          <fcc-input required v-model="configPublicacao.titulo">Título</fcc-input>
        </b-col>
        <b-col class="mt-3" cols="12">
          <fcc-button tipo="submit">{{ editConfig ? 'Editar' : 'Adicionar' }}</fcc-button>
          <fcc-button tipo="button" class="ml-3" v-if="editConfig" @click="editConfig = false"
            >Fechar</fcc-button
          >
        </b-col>
      </b-row>
    </form>
    <fcc-configuracao-definida
      v-else
      :lstSolicitante="lstSolicitante"
      :idNotificacao="idNotificacao"
      @editarSolicitante="editarSolicitante"
      @listarSolicitante="listarSolicitante()"
    />
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import fccConfiguracaoDefinida from './fccConfiguracaoDefinida.vue'

export default {
  data() {
    return {
      lstSolicitante: [],
      editConfig: false,
      lstGabaritoProva: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false }
      ],
      configPublicacao: {
        titulo: 'PUBLICAÇÃO PRELIMINAR DOS GABARITOS E PROVAS OBJETIVAS',
        publicacaoGabarito: true,
        apCodOpcao: true,
        publicacaoProva: true,
        downloadProva: false
      }
    }
  },
  components: {
    fccConfiguracaoDefinida
  },
  props: {
    idNotificacao: String
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.listarSolicitante()
  },
  methods: {
    editarSolicitante(item) {
      this.editConfig = true
      this.configPublicacao = {
        id: this.idNotificacao,
        titulo: item.titulo,
        publicacaoGabarito: item.gabarito === 'SIM',
        apCodOpcao: item.codigodaopcao === 'SIM',
        publicacaoProva: item.prova === 'SIM',
        downloadProva: item.downloadprova === 'SIM',
        dtIniProvaAcesso:
          item.datainicialdeacessoaprova != null
            ? this.$moment(item.datainicialdeacessoaprova, 'DD/MM/YYYY HH:mm:ss').format(
                'YYYY-MM-DDTHH:mm:ss'
              )
            : null,
        dtFimProvaAcesso:
          item.datafinaldeacessoaprova != null
            ? this.$moment(item.datafinaldeacessoaprova, 'DD/MM/YYYY HH:mm:ss').format(
                'YYYY-MM-DDTHH:mm:ss'
              )
            : null,
        dtIniGabaritoAcesso:
          item.datainicialdeacessoaogabarito != null
            ? this.$moment(item.datainicialdeacessoaogabarito, 'DD/MM/YYYY HH:mm:ss').format(
                'YYYY-MM-DDTHH:mm:ss'
              )
            : null
      }
    },
    limpaCampos() {
      if (!this.configPublicacao.publicacaoProva) {
        this.configPublicacao.dtIniProvaAcesso = null
        this.configPublicacao.dtFimProvaAcesso = null
      }
      if (!this.configPublicacao.publicacaoGabarito) {
        this.configPublicacao.dtIniGabaritoAcesso = null
      }
    },
    listarSolicitante() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao +
            `PublicacaoGabarito/SolicitanteConfiguracaoProvaGabarito/${this.idNotificacao}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstSolicitante = response.data ? [response.data] : []
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    editandoConfiguracao() {
      this.callConfirm('Deseja realmente editar?', '').then((result) => {
        if (result.value) {
          const config = {
            titulo: this.configPublicacao.titulo,
            iD_PUBLICACAO: this.configPublicacao.id,
            dT_INI_GABARITO_ACESSO: this.configPublicacao.dtIniProvaAcesso,
            dT_INI_PROVA_ACESSO: this.configPublicacao.dtIniProvaAcesso,
            dT_FIM_PROVA_ACESSO: this.configPublicacao.dtFimProvaAcesso
          }
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .post(
              this.baseUrlPublicacao + 'PublicacaoGabarito/AlterarDatasGabaritoProva',
              config,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarSolicitante()
              this.carregaTexto()
              this.editConfig = false
              this.callToast(this.mensagensUpdate.editado)
            })
            .catch((error) => {
              this.carregaTexto()
              this.setErrorSystem(error)
            })
        }
      })
    },
    adicionaConfiguracao() {
      if (this.configPublicacao.publicacaoGabarito || this.configPublicacao.publicacaoProva) {
        this.callConfirm('Deseja realmente adicionar?', '').then((result) => {
          if (result.value) {
            const payload = {
              ...this.configPublicacao,
              idPublicacao: this.idNotificacao,
              cdFuncionario: this.dadosUserSession.usuCdFuncionario
            }
            this.carregaTexto(this.codeMensagem('C03'))
            axios
              .post(
                this.baseUrlPublicacao + 'PublicacaoGabarito/AdicionarGabaritoConfigProva',
                payload,
                this.dadosLoginSession.fccTokenHeaders
              )
              .then(() => {
                this.listarSolicitante()
                this.carregaTexto()
                this.callToast(this.mensagensUpdate.adicionado)
              })
              .catch((error) => {
                this.carregaTexto()
                this.setErrorSystem(error)
              })
          }
        })
      } else {
        this.callAlert(
          'Erro ao Inserir',
          'A configuração não é permitida: Gabarito Não e Prova Não.',
          'error',
          'error'
        )
      }
    }
  }
}
</script>
